import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

const RedirectConsultation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!id) {
        navigate("/consultation?status=ALL");
      } else {
        navigate(`/consultation/${id}`);
      }
    }, 5000);
    return () => {
      clearTimeout(timer);
    };
  }, [id, navigate]);

  function handleSkip() {
    if (!id) {
      navigate("/consultation?status=ALL");
    } else {
      navigate(`/consultation/${id}`);
    }
  }

  return (
    <div className="max-w-lg mx-auto">
      <div className="bg-white p-8 mt-6 mb-0 space-y-4 rounded-lg shadow-sm text-center">
        <div>
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <div className="mt-3 sm:mt-5">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              {t("Consultation Request Confirmed")}
            </h3>
            <div className="mt-2">
              <p className="text-sm text-gray-500">
                {t("Redirecting you to your consultation page shortly.")}
              </p>
            </div>
          </div>
        </div>
        <div className="mt-5 sm:mt-6">
          <button
            type="button"
            onClick={handleSkip}
            className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            {t("View Consultation")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RedirectConsultation;
